// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.maps-test-page {
  padding: 20px;
  background: #f8f9fa;
  border-radius: 8px;
  height: 100%;
  overflow-y: auto;
}

.maps-test-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  padding-bottom: 15px;
  border-bottom: 2px solid #e9ecef;
}

.maps-test-header h3 {
  margin: 0;
  color: #2c3e50;
  font-size: 1.4rem;
}

.test-status {
  display: flex;
  gap: 10px;
  align-items: center;
}

.status-error {
  color: #dc3545;
  font-weight: 500;
}

.status-loading {
  color: #ffc107;
  font-weight: 500;
}

.status-success {
  color: #28a745;
  font-weight: 500;
}

.maps-test-controls {
  display: flex;
  gap: 20px;
  align-items: end;
  margin-bottom: 20px;
  padding: 15px;
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
}

.control-group {
  display: flex;
  flex-direction: column;
  gap: 5px;
}

.control-group label {
  font-weight: 500;
  color: #495057;
  font-size: 0.9rem;
}

.control-group select {
  padding: 8px 12px;
  border: 1px solid #ced4da;
  border-radius: 4px;
  background: white;
  font-size: 0.9rem;
  min-width: 120px;
}

.search-button {
  padding: 10px 20px;
  background: #007bff;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-weight: 500;
  transition: background-color 0.2s;
}

.search-button:hover:not(:disabled) {
  background: #0056b3;
}

.search-button:disabled {
  background: #6c757d;
  cursor: not-allowed;
}

.map-type-button {
  padding: 10px 20px;
  background: #28a745;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-weight: 500;
  transition: background-color 0.2s;
}

.map-type-button:hover:not(:disabled) {
  background: #218838;
}

.map-type-button:disabled {
  background: #6c757d;
  cursor: not-allowed;
}

.maps-test-content {
  display: grid;
  grid-template-columns: 2fr 1fr;
  gap: 20px;
  height: 500px;
}

.map-container {
  background: white;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
}

.map {
  width: 100%;
  height: 100%;
  min-height: 400px;
}

.map-loading,
.map-error {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  min-height: 400px;
  text-align: center;
  color: #6c757d;
}

.loading-spinner {
  width: 40px;
  height: 40px;
  border: 4px solid #f3f3f3;
  border-top: 4px solid #007bff;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin-bottom: 15px;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.map-loading p,
.map-error p {
  margin: 0 0 5px 0;
  font-weight: 500;
  color: #495057;
}

.map-error {
  color: #dc3545;
}

.error-icon {
  font-size: 2rem;
  margin-bottom: 10px;
}

.map-error small {
  color: #6c757d;
  font-size: 0.85rem;
}

.places-list {
  background: white;
  border-radius: 8px;
  padding: 20px;
  overflow-y: auto;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
}

.places-list h4 {
  margin: 0 0 15px 0;
  color: #2c3e50;
  font-size: 1.1rem;
  border-bottom: 1px solid #e9ecef;
  padding-bottom: 10px;
}

.no-results {
  color: #6c757d;
  font-style: italic;
  text-align: center;
  margin: 40px 0;
}

.place-item {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  padding: 12px 0;
  border-bottom: 1px solid #f1f3f4;
  gap: 10px;
}

.place-item:last-child {
  border-bottom: none;
}

.place-info {
  flex: 1 1;
}

.place-info h5 {
  margin: 0 0 5px 0;
  color: #2c3e50;
  font-size: 0.95rem;
  line-height: 1.3;
}

.place-address {
  margin: 0 0 8px 0;
  color: #6c757d;
  font-size: 0.85rem;
  line-height: 1.2;
}

.place-meta {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
}

.place-rating,
.place-price,
.place-type {
  font-size: 0.8rem;
  padding: 2px 6px;
  border-radius: 3px;
  background: #f8f9fa;
  color: #495057;
}

.place-rating {
  background: #fff3cd;
  color: #856404;
}

.place-price {
  background: #d1ecf1;
  color: #0c5460;
}

.details-button {
  padding: 6px 12px;
  background: #28a745;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 0.8rem;
  white-space: nowrap;
  transition: background-color 0.2s;
}

.details-button:hover {
  background: #218838;
}

.api-info {
  margin-top: 20px;
  background: white;
  border-radius: 8px;
  padding: 20px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
}

.api-info h4 {
  margin: 0 0 15px 0;
  color: #2c3e50;
  font-size: 1.1rem;
}

.api-status-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 15px;
}

.api-status-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px;
  background: #f8f9fa;
  border-radius: 4px;
}

.api-label {
  font-weight: 500;
  color: #495057;
  font-size: 0.9rem;
}

.api-value {
  font-weight: 500;
  font-size: 0.9rem;
}

.api-value.success {
  color: #28a745;
}

.api-value.error {
  color: #dc3545;
}

.api-value.warning {
  color: #ffc107;
}

/* Responsive design */
@media (max-width: 768px) {
  .maps-test-content {
    grid-template-columns: 1fr;
    height: auto;
  }
  
  .map-container {
    height: 300px;
  }
  
  .maps-test-controls {
    flex-direction: column;
    align-items: stretch;
  }
  
  .control-group {
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  }
  
  .api-status-grid {
    grid-template-columns: 1fr;
  }
} `, "",{"version":3,"sources":["webpack://./src/components/MapsTestPage.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,SAAS;EACT,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,iBAAiB;EACjB,kBAAkB;EAClB,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,qCAAqC;AACvC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;;EAEE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,6BAA6B;EAC7B,kBAAkB;EAClB,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA;EACE,KAAK,uBAAuB,EAAE;EAC9B,OAAO,yBAAyB,EAAE;AACpC;;AAEA;;EAEE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;EACb,gBAAgB;EAChB,qCAAqC;AACvC;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,iBAAiB;EACjB,gCAAgC;EAChC,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,eAAe;EACf,gCAAgC;EAChC,SAAS;AACX;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;AACjB;;AAEA;;;EAGE,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,iCAAiC;AACnC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;EACb,qCAAqC;AACvC;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA,sBAAsB;AACtB;EACE;IACE,0BAA0B;IAC1B,YAAY;EACd;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,sBAAsB;IACtB,oBAAoB;EACtB;;EAEA;IACE,mBAAmB;IACnB,8BAA8B;IAC9B,mBAAmB;EACrB;;EAEA;IACE,0BAA0B;EAC5B;AACF","sourcesContent":[".maps-test-page {\n  padding: 20px;\n  background: #f8f9fa;\n  border-radius: 8px;\n  height: 100%;\n  overflow-y: auto;\n}\n\n.maps-test-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 20px;\n  padding-bottom: 15px;\n  border-bottom: 2px solid #e9ecef;\n}\n\n.maps-test-header h3 {\n  margin: 0;\n  color: #2c3e50;\n  font-size: 1.4rem;\n}\n\n.test-status {\n  display: flex;\n  gap: 10px;\n  align-items: center;\n}\n\n.status-error {\n  color: #dc3545;\n  font-weight: 500;\n}\n\n.status-loading {\n  color: #ffc107;\n  font-weight: 500;\n}\n\n.status-success {\n  color: #28a745;\n  font-weight: 500;\n}\n\n.maps-test-controls {\n  display: flex;\n  gap: 20px;\n  align-items: end;\n  margin-bottom: 20px;\n  padding: 15px;\n  background: white;\n  border-radius: 8px;\n  box-shadow: 0 2px 4px rgba(0,0,0,0.1);\n}\n\n.control-group {\n  display: flex;\n  flex-direction: column;\n  gap: 5px;\n}\n\n.control-group label {\n  font-weight: 500;\n  color: #495057;\n  font-size: 0.9rem;\n}\n\n.control-group select {\n  padding: 8px 12px;\n  border: 1px solid #ced4da;\n  border-radius: 4px;\n  background: white;\n  font-size: 0.9rem;\n  min-width: 120px;\n}\n\n.search-button {\n  padding: 10px 20px;\n  background: #007bff;\n  color: white;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n  font-weight: 500;\n  transition: background-color 0.2s;\n}\n\n.search-button:hover:not(:disabled) {\n  background: #0056b3;\n}\n\n.search-button:disabled {\n  background: #6c757d;\n  cursor: not-allowed;\n}\n\n.map-type-button {\n  padding: 10px 20px;\n  background: #28a745;\n  color: white;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n  font-weight: 500;\n  transition: background-color 0.2s;\n}\n\n.map-type-button:hover:not(:disabled) {\n  background: #218838;\n}\n\n.map-type-button:disabled {\n  background: #6c757d;\n  cursor: not-allowed;\n}\n\n.maps-test-content {\n  display: grid;\n  grid-template-columns: 2fr 1fr;\n  gap: 20px;\n  height: 500px;\n}\n\n.map-container {\n  background: white;\n  border-radius: 8px;\n  overflow: hidden;\n  box-shadow: 0 2px 8px rgba(0,0,0,0.1);\n}\n\n.map {\n  width: 100%;\n  height: 100%;\n  min-height: 400px;\n}\n\n.map-loading,\n.map-error {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  height: 100%;\n  min-height: 400px;\n  text-align: center;\n  color: #6c757d;\n}\n\n.loading-spinner {\n  width: 40px;\n  height: 40px;\n  border: 4px solid #f3f3f3;\n  border-top: 4px solid #007bff;\n  border-radius: 50%;\n  animation: spin 1s linear infinite;\n  margin-bottom: 15px;\n}\n\n@keyframes spin {\n  0% { transform: rotate(0deg); }\n  100% { transform: rotate(360deg); }\n}\n\n.map-loading p,\n.map-error p {\n  margin: 0 0 5px 0;\n  font-weight: 500;\n  color: #495057;\n}\n\n.map-error {\n  color: #dc3545;\n}\n\n.error-icon {\n  font-size: 2rem;\n  margin-bottom: 10px;\n}\n\n.map-error small {\n  color: #6c757d;\n  font-size: 0.85rem;\n}\n\n.places-list {\n  background: white;\n  border-radius: 8px;\n  padding: 20px;\n  overflow-y: auto;\n  box-shadow: 0 2px 8px rgba(0,0,0,0.1);\n}\n\n.places-list h4 {\n  margin: 0 0 15px 0;\n  color: #2c3e50;\n  font-size: 1.1rem;\n  border-bottom: 1px solid #e9ecef;\n  padding-bottom: 10px;\n}\n\n.no-results {\n  color: #6c757d;\n  font-style: italic;\n  text-align: center;\n  margin: 40px 0;\n}\n\n.place-item {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  padding: 12px 0;\n  border-bottom: 1px solid #f1f3f4;\n  gap: 10px;\n}\n\n.place-item:last-child {\n  border-bottom: none;\n}\n\n.place-info {\n  flex: 1;\n}\n\n.place-info h5 {\n  margin: 0 0 5px 0;\n  color: #2c3e50;\n  font-size: 0.95rem;\n  line-height: 1.3;\n}\n\n.place-address {\n  margin: 0 0 8px 0;\n  color: #6c757d;\n  font-size: 0.85rem;\n  line-height: 1.2;\n}\n\n.place-meta {\n  display: flex;\n  gap: 10px;\n  flex-wrap: wrap;\n}\n\n.place-rating,\n.place-price,\n.place-type {\n  font-size: 0.8rem;\n  padding: 2px 6px;\n  border-radius: 3px;\n  background: #f8f9fa;\n  color: #495057;\n}\n\n.place-rating {\n  background: #fff3cd;\n  color: #856404;\n}\n\n.place-price {\n  background: #d1ecf1;\n  color: #0c5460;\n}\n\n.details-button {\n  padding: 6px 12px;\n  background: #28a745;\n  color: white;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 0.8rem;\n  white-space: nowrap;\n  transition: background-color 0.2s;\n}\n\n.details-button:hover {\n  background: #218838;\n}\n\n.api-info {\n  margin-top: 20px;\n  background: white;\n  border-radius: 8px;\n  padding: 20px;\n  box-shadow: 0 2px 4px rgba(0,0,0,0.1);\n}\n\n.api-info h4 {\n  margin: 0 0 15px 0;\n  color: #2c3e50;\n  font-size: 1.1rem;\n}\n\n.api-status-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));\n  gap: 15px;\n}\n\n.api-status-item {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 10px;\n  background: #f8f9fa;\n  border-radius: 4px;\n}\n\n.api-label {\n  font-weight: 500;\n  color: #495057;\n  font-size: 0.9rem;\n}\n\n.api-value {\n  font-weight: 500;\n  font-size: 0.9rem;\n}\n\n.api-value.success {\n  color: #28a745;\n}\n\n.api-value.error {\n  color: #dc3545;\n}\n\n.api-value.warning {\n  color: #ffc107;\n}\n\n/* Responsive design */\n@media (max-width: 768px) {\n  .maps-test-content {\n    grid-template-columns: 1fr;\n    height: auto;\n  }\n  \n  .map-container {\n    height: 300px;\n  }\n  \n  .maps-test-controls {\n    flex-direction: column;\n    align-items: stretch;\n  }\n  \n  .control-group {\n    flex-direction: row;\n    justify-content: space-between;\n    align-items: center;\n  }\n  \n  .api-status-grid {\n    grid-template-columns: 1fr;\n  }\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
